import axios from "axios";
import ResponseAlerts from "../functions/ResponseAlerts";

const BASE_TAG = "identity-service/identity/tags";

const RESOURCES = {
	PAGINATED_TAGS: (page, searchText, clientId, orderBy) =>
		`${BASE_TAG}/organizations/${clientId}/paginated?page=${page}&limit=8` +
		`&searchBy=${searchText}&orderBy=${orderBy.collumnTitle}&orderDirection=${orderBy.orderDirection}`,
	LIST_TAGS_BY_CLIENT_AND_TYPE: (clientId, type) => `${BASE_TAG}/organization/${clientId}?type=${type}`,
	GET_TAG: (id) => `${BASE_TAG}/${id}/s`,
	CREATE_TAG: () => `${BASE_TAG}`,
	UPDATE_TAG: (id) => `${BASE_TAG}/${id}`,
	DELETE_TAG: (id) => `${BASE_TAG}/${id}`,
};

class TagService {
	static async getPaginatedTags(page, searchText, clientId, orderBy) {
		try {
			return await axios.get(
				RESOURCES.PAGINATED_TAGS(page, searchText, clientId, orderBy),
			);
		} catch (error) {
			console.log(error);
			ResponseAlerts({
				response: error.response,
				errorMessage: error.response?.data?.message ?? "Erro ao listar etiquetas paginadas",
			});
			return error.response;
		}
	}

	static async listTagsByClientAndType(clientId, type = '') {
		try {
			return await axios.get(RESOURCES.LIST_TAGS_BY_CLIENT_AND_TYPE(clientId, type));
		} catch (error) {
			console.log(error);
			ResponseAlerts({
				response: error.response,
				errorMessage: error.response?.data?.message ?? "Erro ao listar etiquetas",
			});
			return error.response;
		}
	}

	static async getTag(id) {
		try {
			return await axios.get(RESOURCES.GET_TAG(id));
		} catch (error) {
			console.log(error);
			ResponseAlerts({
				response: error.response,
				errorMessage: error.response?.data?.message ?? "Erro ao buscar etiqueta",
			});
			return error.response;
		}
	}

	static async createTag(payload) {
		try {
			const response = await axios.post(RESOURCES.CREATE_TAG(), payload);
			ResponseAlerts({
				response,
				successMessage: "Etiqueta criada com sucesso",
			});
			return response;
		} catch (error) {
			console.log(error);
			ResponseAlerts({
				response: error.response,
				errorMessage: error.response?.data?.message ?? "Erro ao criar etiqueta",
			});
			return error.response;
		}
	}

	static async updateTag(id, payload) {
		try {
			const response = await axios.put(RESOURCES.UPDATE_TAG(id), payload);
			ResponseAlerts({
				response,
				successMessage: "Etiqueta atualizada com sucesso",
			});
			return response;
		} catch (error) {
			console.log(error);
			ResponseAlerts({
				response: error.response,
				errorMessage: error.response?.data?.message ?? "Erro ao atualizar etiqueta",
			});
			return error.response;
		}
	}

	static async deleteTag(id) {
		try {
			const response = await axios.delete(RESOURCES.DELETE_TAG(id));
			ResponseAlerts({
				response,
				successMessage: "Etiqueta removida com sucesso",
			});
			return response;
		} catch (error) {
			console.log(error);
			ResponseAlerts({
				response: error.response,
				errorMessage: error.response?.data?.message ?? "Erro ao remover etiqueta",
			});
			return error.response;
		}
	}
}

export default TagService;
